export type RunRewardGoalKind = "combo" | "perfect" | "songAlive" | "distance" | "musicEnergy";

export interface RunRewardGoalConfig {
  id: string;
  kind: RunRewardGoalKind;
  target: number;
  text: string;
  tone: "energy" | "champion" | "warning";
}

export const RUN_REWARD_CONFIG = {
  comboHudFadeSeconds: 1.4,
  goals: [
    { id: "first-perfect", kind: "perfect", target: 1, text: "ENERGIA FINA", tone: "energy" },
    { id: "combo-4", kind: "combo", target: 4, text: "CADENA x4", tone: "energy" },
    { id: "combo-8", kind: "combo", target: 8, text: "AURA x8", tone: "champion" },
    { id: "combo-12", kind: "combo", target: 12, text: "AURA x12", tone: "champion" },
    { id: "song-30", kind: "songAlive", target: 30, text: "30s CON CANCION", tone: "energy" },
    { id: "song-60", kind: "songAlive", target: 60, text: "60s CON CANCION", tone: "champion" },
    { id: "distance-500", kind: "distance", target: 500, text: "500m AL NORTE", tone: "energy" },
    { id: "distance-1000", kind: "distance", target: 1000, text: "1000m AL NORTE", tone: "champion" },
    { id: "energy-full", kind: "musicEnergy", target: 0.96, text: "AURA LLENA", tone: "champion" }
  ] satisfies RunRewardGoalConfig[]
} as const;
